export enum LayoutVisibility {
  HIDING = "HIDING",
  HIDDEN = "HIDDEN",
  SHOWING = "SHOWING",
  SHOWN = "SHOWN",
}
